// === Connection store — global online/offline + API reachability state ===

import { create } from 'zustand';

export interface ConnectionStatus {
  readonly online: boolean;
  readonly apiReachable: boolean;
  readonly lastChecked: Date | null;
}

interface ConnectionStore extends ConnectionStatus {
  setStatus: (s: Partial<ConnectionStatus>) => void;
}

export const useConnectionStore = create<ConnectionStore>((set) => ({
  online: typeof navigator !== 'undefined' ? navigator.onLine : true,
  apiReachable: true,
  lastChecked: null,
  setStatus: (s) => set(s),
}));

export const useIsConnected = (): boolean =>
  useConnectionStore((s) => s.online && s.apiReachable);
